export const COLUMNS_HEIGHT_IN_PX = 425;
export const DIALOG_WIDTH_IN_PX = 600;
export const DraggableTypes = Object.freeze({
  COLUMN: 'COLUMN',
  DRAGGABLE_CONTENT: 'DRAGGABLE_CONTENT',
  DRAGGABLE_FOLDER: 'DRAGGABLE_FOLDER'
});